import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { connect } from 'react-redux';
import ReactLoading from 'react-loading';
import { Helmet } from 'react-helmet'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {
  GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3';
import { ApolloProvider } from '@apollo/client';

// Main Stylesheet
import './styles/incredible/incredible.css';
// Actions
import * as UIActions from './actions/uiAction';
// Components
import NavigationBar from './Components/misc/NavigationBar';
import Home from './Components/home/Home';
import Signup from './Components/signup/Signup';
import Login from './Components/login/Login';
import ForgotPassword from './Components/forgotPassword/ForgotPassword';
import Pricing from './Components/pricing/Pricing';
import MyCart from './Components/cart/Cart';
import Profile from './Components/profile/Profile';
import Resources from './Components/resources/Resources';
import NotFound from './Components/misc/404';
import { AppConfig } from './configs'

const theme = createMuiTheme({
  overrides: {

  }
});

const { recaptcha_id, client } = AppConfig

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.errorMessage && (!prevProps.errorMessage || prevProps.errorMessage !== this.props.errorMessage)) {
      toast.error(this.props.errorMessage, {
        onClose: (childrenProps) => this.props.clearErrMsg()
      })
    }

    if (this.props.successMessage && (!prevProps.successMessage || prevProps.successMessage !== this.props.successMessage)) {
      toast.success(this.props.successMessage, {
        onClose: (childrenProps) => this.props.clearSuccMsg()
      })
    }
  }


  render() {
    const { loading } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <GoogleReCaptchaProvider reCaptchaKey={recaptcha_id}>
          <ApolloProvider client={client}>
            <div className="App">

              <Helmet>
                <title>Question Bank</title>
                <meta name="description" content="testing react helmet" />
                <meta name="keywords" content="question,bank,test" />
              </Helmet>

              <ToastContainer
                position="top-center"
                type="error"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                pauseOnHover
                style={{
                  zIndex: 999999999999999
                }}
              />

              {loading && (
                <div className="appLoadingCont">
                  <ReactLoading
                    type="spinningBubbles"
                    color="#ffc411"
                  />
                </div>
              )}

              <NavigationBar />

              <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/signup" component={Signup} />
                <Route path="/login" component={Login} />
                <Route path="/forgot-password" component={ForgotPassword} />
                <Route path="/pricing" component={Pricing} />
                <Route path="/cart" component={MyCart} />
                <Route path="/profile" component={Profile} />
                <Route path="/resources" component={Resources} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </ApolloProvider>
        </GoogleReCaptchaProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = ({ UiStore }) => ({
  errorMessage: UiStore.errorMessage,
  successMessage: UiStore.successMessage,
  loading: UiStore.loading,
});

const mapDispatchToProps = (dispatch) => ({
  clearErrMsg: () => dispatch(UIActions.resetError()),
  clearSuccMsg: () => dispatch(UIActions.resetSuccess()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js